export default __webpack_public_path__ + "static/media/Lato-Thin.01923cbb.ttf";